import axios from 'axios'
import { Message } from 'element-ui'
// 开发环境直接写完整后端地址，不再依赖webpack代理！
const service = axios.create({
  baseURL: 'https://asdf.hbbtfbf.cn/api',
  // baseURL: 'http://124.221.86.200:80/api',
  timeout: 10000
})
let isRefreshing = false
// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// 响应拦截器（适配后端 code=200 代表成功）
service.interceptors.response.use(
  response => {
    const res = response.data
    if (!res) {
      Message.error('接口返回数据为空')
      return Promise.reject(new Error('接口返回数据为空'))
    }
    const isLoginApi = response.config.url.includes('action.php?act=login')
    if (res.code === 401 && !isLoginApi) {
      if (!isRefreshing) {
        isRefreshing = true
        localStorage.removeItem('token')
        Message.error(res.msg || '登录已过期，请重新登录')
        import('@/router').then(({ default: router }) => {
          router.push('/login').finally(() => {
            isRefreshing = false
          })
        })
      }
      return Promise.reject(new Error(res.msg || '登录已过期'))
    }
    // ========== 这里重点修改：判断code===200为成功 ==========
    if (res.code !== 200) {
      Message.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  error => {
    if (error.message.includes('timeout')) {
      Message.error('请求超时，请检查网络')
    }
    if (!error.response) {
      Message.error('网络请求异常，请检查网络连接')
    } else {
      const { status } = error.response
      if (status === 401) {
        if (!isRefreshing) {
          isRefreshing = true
          localStorage.removeItem('token')
          Message.error('登录已过期，请重新登录')
          import('@/router').then(({ default: router }) => {
            router.push('/login').finally(() => {
              isRefreshing = false
            })
          })
        }
      } else if (status === 500) {
        Message.error('服务器内部错误')
      } else if (status === 404) {
        Message.error('接口地址不存在')
      } else if (status === 403) {
        Message.error('没有权限访问')
      } else {
        Message.error(`请求错误：${status}`)
      }
    }
    return Promise.reject(error)
  }
)
export default service
